import Animations from './Animations'
import Blocks from './Blocks'
import Common from './Common'
import Header from './Header'

const init = async () =>
    await Promise.all([Animations(), Blocks(), Common(), Header()])

window.addEventListener('load', init)
